import React from 'react';
import { Row, Col, Alert } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Draggable from 'react-draggable';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import './login.css';

export class LoginResetPasswordForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newPasswordVisible: false,
      confirmPasswordVisible: false,
      deltaPosition: { x: 0, y: 0 },
    };

    this.setPNewasswordVisible = this.setNewPasswordVisible.bind(this);
    this.setConfirmPasswordVisible = this.setConfirmPasswordVisible.bind(this);
    this.keydownHandler = this.keydownHandler.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.setNewPasswordVisible = this.setNewPasswordVisible.bind(this);
    this.setConfirmPasswordVisible = this.setConfirmPasswordVisible.bind(this);

    this.newResetCodeRef = React.createRef();
  }
  componentDidMount() {
    this.setState({ isMounted: true }); // Set isMounted to true when the component mounts

    document.addEventListener('keydown', this.keydownHandler);

    // Set focus to the new password field
    setTimeout(() => {
      if (this.newResetCodeRef.current) {
        this.newResetCodeRef.current.focus();
      }
    }, 100);

    return () => {
      document.removeEventListener('keydown', this.keydownHandler);
    };
  }

  componentWillUnmount() {
    this.setState({ isMounted: false }); // Set isMounted to false when the component unmounts
    document.removeEventListener('keydown', this.keydownHandler);
  }

  onStart = () => {};

  onStop = () => {};

  handleDrag = (e, ui) => {
    const { deltaPosition = { x: 0, y: 0 } } = this.state || {};
    this.setState({
      deltaPosition: {
        x: deltaPosition.x + ui.deltaX,
        y: deltaPosition.y + ui.deltaY,
      },
    });
  };

  async keydownHandler(e) {
    if (e.keyCode === 13) {
      this.props.handlePasswordResetRequest();
    }
    if (e.keyCode === 27) {
      this.handleCancel();
    }
  }

  handleCancel = () => {
    this.props.handleResetModel();
    this.props.setResetPasswordModal(false);
  };

  setNewPasswordVisible(newPasswordVisible) {
    this.setState({ newPasswordVisible });
  }

  setConfirmPasswordVisible(confirmPasswordVisible) {
    this.setState({ confirmPasswordVisible });
  }

  render() {
    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
    const { deltaPosition = { x: 0, y: 0 } } = this.state || {};

    return (
      <Draggable
        handle=".login-reset-password-handle"
        onDrag={this.handleDrag}
        {...dragHandlers}
      >
        <Modal
          isOpen={this.props.resetPasswordModal}
          toggle={this.props.setResetPasswordModal}
          style={{
            transform: `translate(${deltaPosition.x}px, ${deltaPosition.y}px)`,
            width: '500px',
            height: '300px',
          }}
          backdrop="static"
        >
          <ModalHeader
            className="login-reset-password-handle handle"
            style={{ textAlign: 'center', display: 'block', width: '100%' }}
        >
          <div
            className="header-content"
            style={{ width: '100%', textAlign: 'center', display: 'block' }}
          >
            <h5
              className="modal-title"
              style={{ textAlign: 'center', margin: 0, display: 'block' }}
            >
              Reset Password
            </h5>
            <h6
              style={{
                textAlign: 'center',
                margin: 0,
                width: '100%',
                display: 'block',
                fontWeight: 'normal',
              }}
            >
              A reset code has been sent to {this.props.reset_email}
            </h6>
          </div>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col style={{ textAlign: 'center' }}>
              <Alert
                color={this.props.alert.color}
                isOpen={this.props.alert.isOpen}
              >
                {this.props.alert.message}
              </Alert>
            </Col>
          </Row>
          <form
            autoComplete="off"
            onSubmit={(e) => e.preventDefault()}
            autoCorrect="off"
            autoCapitalize="none"
            spellCheck={false}
          >
            <div className="form-group">
              <label htmlFor="reset_code">Reset Code</label>
              <input
                type="text"
                name="reset_code"
                className="form-control"
                id="reset_code"
                ref={this.newResetCodeRef}
                value={this.props.reset_code}
                onChange={this.props.handleChange}
                onBlur={(e) => {
                  const trimmedValue = e.target.value.trim();
                  if (trimmedValue !== e.target.value) {
                    this.props.handleChange({
                      target: { name: 'reset_code', value: trimmedValue },
                    });
                  }
                }}
                placeholder="Enter the reset code"
                autoComplete="one-time-code"
                autoCorrect="off"
                autoCapitalize="none"
                spellCheck={false}
                inputMode="numeric"
              />
            </div>
            <div className="form-group">
              <label htmlFor="new_password" style={{ color: 'red' }}>
                Password must have, contain upper and lower case, a number and a
                special character.
              </label>
              <label htmlFor="new_password">New Password</label>
              <div style={{ position: 'relative' }}>
                <input
                  type={this.state.newPasswordVisible ? 'text' : 'password'}
                  name="new_password"
                  className="form-control"
                  id="new_password"
                  value={this.props.new_password}
                  onChange={this.props.handleChange}
                  placeholder="Enter your new password"
                  autoComplete="new-password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  spellCheck={false}
                  style={{ paddingRight: '2.5rem' }} // Add padding to the right to make space for the icon
                />
                <span
                  className="password-toggle-icon"
                  onClick={() =>
                    this.setNewPasswordVisible(!this.state.newPasswordVisible)
                  }
                  style={{
                    position: 'absolute',
                    right: '0.5rem',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                  }}
                >
                  {this.state.newPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="confirm_password">Confirm Password</label>
              <div style={{ position: 'relative' }}>
                <input
                  type={this.state.confirmPasswordVisible ? 'text' : 'password'}
                  name="confirm_password"
                  className="form-control"
                  id="confirm_password"
                  value={this.props.confirm_password}
                  onChange={this.props.handleChange}
                  placeholder="Confirm your new password"
                  autoComplete="new-password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  spellCheck={false}
                  style={{ paddingRight: '2.5rem' }} // Add padding to the right to make space for the icon
                />
                <span
                  className="password-toggle-icon"
                  onClick={() =>
                    this.setConfirmPasswordVisible(
                      !this.state.confirmPasswordVisible
                    )
                  }
                  style={{
                    position: 'absolute',
                    right: '0.5rem',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                  }}
                >
                  {this.state.confirmPasswordVisible ? (
                    <FaEyeSlash />
                  ) : (
                    <FaEye />
                  )}
                </span>
              </div>
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-primary"
            onClick={this.props.handleResetPassword}
          >
            Submit
          </button>
          <button
            type="button"
            className="btn btn-default"
            data-dismiss="modal"
            onClick={this.handleCancel}
          >
            Cancel
          </button>
        </ModalFooter>
      </Modal>
      </Draggable>
    );
  }
}
